module.exports = __webpack_public_path__ + "static/media/storm_page10.a49dd387.png";